import { createContext, useEffect, useReducer } from "react";

import altaProtocoloPcrInitialState from "./initialStates/altaProtocoloPcrInitialState";
import ayudaInitialState from "./initialStates/ayudaInitialState";
import enviarMailInitialState from "./initialStates/enviarMailInitialState";
import modalInitialState from "./initialStates/modalInitialState";
import segundoModalInitialState from "./initialStates/segundoModalInitialState";
import localidadInitialState from "./initialStates/localidadInitialState";
import obraSocialInitialState from "./initialStates/obraSocialInitialState";
import planObraSocialInitialState from "./initialStates/planObraSocialInitialState";
import verificaDniInitialState from "./initialStates/verificaDniInitialState";
import registroInitialState from "./initialStates/registroInitialState";
import multiTabInitialState from "./initialStates/multiTabInitialState";
import validaMobileInitialState from "./initialStates/validaMobileInitialState";
import pacienteInitialState from "./initialStates/pacienteInitialState";
import tokenInitialState from "./initialStates/tokenInitialState";
import vcTokenInitialState from "./initialStates/vcTokenInitialState";
import estudioGrupoInitialState from "./initialStates/estudioGrupoInitialState";
import familiaresInitialState from "./initialStates/familiaresInitialState";
import laboGrupoInitialState from "./initialStates/laboGrupoInitialState";
import laboTurnosInitialState from "./initialStates/laboTurnosInitialState";
import misMedicosInitialState from "./initialStates/misMedicosInitialState";
import misLaboratoriosInitialState from "./initialStates/misLaboratoriosInitialState";
import misInformesInitialState from "./initialStates/misInformesInitialState";
import cancelacionInitialState from "./initialStates/cancelacionInitialState";
import tokenGoogleInitialState from "./initialStates/accessTokenInitialState";
import estudioTurnosInitialState from "./initialStates/estudioTurnosInitialState";
import textosInitialState from "./initialStates/textosInitialState";
import consultaMedTurnosInitialState from "./initialStates/consultaMedTurnosInitialState";
import sugerenciaInitialState from "./initialStates/sugerenciaInitialState";
import turnosDisponiblesInitialState from "./initialStates/turnosDisponiblesInitialState";
import atencionSinTurnoInitialState from "./initialStates/atencionSinTurnoInitialState";
import mercadoPagoInitialState from "./initialStates/mercadoPagoInitialState";
import motivoCancelacionInitialState from "./initialStates/motivoCancelacionInitialState";
import multitabSinTurnoInitialState from "./initialStates/multitabSinTurnoInitialState";
import ordenEstudioInitialState from "./initialStates/ordenEstudioInitialState";
import ordenLaboratorioInitialState from "./initialStates/ordenLaboratorioInitialState";
import preguntasFrecuentesInitialState from "./initialStates/preguntasFrecuentesInitialState";
import recetasDigitalesInitialState from "./initialStates/recetasDigitalesInitialState";
import certificadoInitialState from "./initialStates/certificadoInitialState";
import portalExteriorPacienteInitialState from "./initialStates/portalExteriorPacienteInitialState";
import turnosPacienteInitialState from "./initialStates/turnosPacienteInitialState";
import grupoFamiliarInitialState from "./initialStates/grupoFamiliarInitialState";
import listaFamiliaresInitialState from "./initialStates/listaFamiliaresInitialState";
import selectDropDownInitialState from "./initialStates/selectDropDownState";
import tokenFCMInitialState from "./initialStates/tokenFCMInitialState";
import dispositivoPacienteInitialState from "./initialStates/dispositivoPacienteInitialState";
import alertasInitialState from "./initialStates/alertasInitialState";
import labOrdenDigitalInitialState from "./initialStates/labOrdenDigitalInitialState";
import ordenDigitalInitialState from "./initialStates/ordenDigitalInitialState";
import presentismoInitialState from "./initialStates/presentismoInitialState";
import beneficiosInitialState from "./initialStates/beneficiosInitialState";
import pdfOrdenDigitalInitialState from "./initialStates/pdfOrdenDigitalInitialState";
import hashInitialState from "./initialStates/hashInitialState";

import altaProtocoloPcr from "./reducers/altaProtocoloPcr";
import ayuda from "./reducers/ayuda";
import enviarMail from "./reducers/enviarMail";
import modal from "./reducers/modal";
import segundoModal from "./reducers/segundoModal";
import localidad from "./reducers/localidad";
import obraSocial from "./reducers/obraSocial";
import planObraSocial from "./reducers/planObraSocial";
import verificaDni from "./reducers/verificaDni";
import registro from "./reducers/registro";
import multiTab from "./reducers/multiTab";
import validaMobile from "./reducers/validaMobile";
import paciente from "./reducers/paciente";
import token from "./reducers/token";
import vcToken from "./reducers/vcToken";
import estudioGrupo from "./reducers/estudioGrupo";
import familiares from "./reducers/familiares";
import laboGrupo from "./reducers/laboGrupo";
import laboTurnos from "./reducers/laboTurnos";
import misMedicos from "./reducers/misMedicos";
import misLaboratorios from "./reducers/misLaboratorios";
import misInformes from "./reducers/misInformes";
import cancelacion from "./reducers/cancelacion";
import tokenGoogle from "./reducers/accessToken";
import estudioTurnos from "./reducers/estudioTurnos";
import textos from "./reducers/textos";
import consultaMedTurnos from "./reducers/consultaMedTurnos";
import sugerencia from "./reducers/sugerencia";
import turnosDisponibles from "./reducers/turnosDisponibles";
import atencionSinTurno from "./reducers/atencionSinTurno";
import mercadoPago from "./reducers/mercadoPago";
import motivoCancelacion from "./reducers/motivoCancelacion";
import multitabSinTurno from "./reducers/multitabSinTurno";
import ordenEstudio from "./reducers/ordenEstudio";
import ordenLaboratorio from "./reducers/ordenLaboratorio";
import preguntasFrecuente from "./reducers/preguntasFrecuente";
import recetasDigitales from "./reducers/recetasDigitales";
import certificado from "./reducers/certificado";
import portalExterior from "./reducers/portalExterior";
import turnosPaciente from "./reducers/turnosPaciente";
import grupoFamiliar from "./reducers/grupoFamiliar";
import listaFamiliares from "./reducers/listaFamiliares";
import selectDropDown from "./reducers/selectDropDown";
import tokenFCM from "./reducers/tokenFCM";
import alertas from "./reducers/alertas";
import labOrdenDigital from "./reducers/labOrdenDigital";
import ordenDigital from "./reducers/ordenDigital";
import presentismo from "./reducers/presentismo";
import beneficios from "./reducers/beneficios";
import pdfOrdenDigital from "./reducers/pdfOrdenDigital";
import hash from "./reducers/hash";

//eslint-disable-next-line
import cardVideoTutoriales from "./reducers/cardVideoTutoriales";
import { initialStateCardVideoTutoriales } from "./initialStates/cardVideoTutoriales";
import notificaionInitialState from "./initialStates/notificacion";
import notificacionesReducer from "./reducers/notificaciones";
import dispositivoPaciente from "./reducers/dispositivoPaciente";
import { RESET_PORTAL_CONTEXT } from "./ActionTypes";
import { useHistory } from "react-router";
import { Network } from "@capacitor/network";

export const PortalContext = createContext();

export const PortalProvider = ({ children }) => {
  const [modalState, modalDispatch] = useReducer(modal, modalInitialState);
  const [segundoModalState, segundoModalDispatch] = useReducer(
    segundoModal,
    segundoModalInitialState
  );
  const [localidadState, localidadDispatch] = useReducer(
    localidad,
    localidadInitialState
  );
  const [obraSocialState, obraSocialDispatch] = useReducer(
    obraSocial,
    obraSocialInitialState
  );
  const [planObraSocialState, planObraSocialDispatch] = useReducer(
    planObraSocial,
    planObraSocialInitialState
  );
  const [verificaDniState, verificaDniDispatch] = useReducer(
    verificaDni,
    verificaDniInitialState
  );
  const [registroState, registroDispatch] = useReducer(
    registro,
    registroInitialState
  );
  const [multiTabState, multiTabDispatch] = useReducer(
    multiTab,
    multiTabInitialState
  );
  const [validaMobileState, validaMobileDispatch] = useReducer(
    validaMobile,
    validaMobileInitialState
  );
  const [pacienteState, pacienteDispatch] = useReducer(
    paciente,
    pacienteInitialState
  );
  const [tokenState, tokenDispatch] = useReducer(token, tokenInitialState);
  const [hashState, hashDispatch] = useReducer(hash, hashInitialState);
  const [estudioGrupoState, estudioGrupoDispatch] = useReducer(
    estudioGrupo,
    estudioGrupoInitialState
  );
  const [familiaresState, familiaresDispatch] = useReducer(
    familiares,
    familiaresInitialState
  );
  const [laboGrupoState, laboGrupoDispatch] = useReducer(
    laboGrupo,
    laboGrupoInitialState
  );
  const [laboTurnosState, laboTurnosDispatch] = useReducer(
    laboTurnos,
    laboTurnosInitialState
  );
  const [misMedicosState, misMedicosDispatch] = useReducer(
    misMedicos,
    misMedicosInitialState
  );
  const [misLaboratoriosState, misLaboratoriosDispatch] = useReducer(
    misLaboratorios,
    misLaboratoriosInitialState
  );
  const [misInformesState, misInformesDispatch] = useReducer(
    misInformes,
    misInformesInitialState
  );
  const [cancelacionState, cancelacionDispatch] = useReducer(
    cancelacion,
    cancelacionInitialState
  );
  const [tokenGoogleState, tokenGoogleDispatch] = useReducer(
    tokenGoogle,
    tokenGoogleInitialState
  );
  const [estudioTurnosState, estudioTurnosDispatch] = useReducer(
    estudioTurnos,
    estudioTurnosInitialState
  );
  const [textosState, textosDispatch] = useReducer(textos, textosInitialState);
  const [consultaMedTurnosState, consultaMedTurnosDispatch] = useReducer(
    consultaMedTurnos,
    consultaMedTurnosInitialState
  );
  const [sugerenciaState, sugerenciaDispatch] = useReducer(
    sugerencia,
    sugerenciaInitialState
  );
  const [atencionSinTurnoState, atencionSinTurnoDispatch] = useReducer(
    atencionSinTurno,
    atencionSinTurnoInitialState
  );
  const [turnosDisponiblesState, turnosDisponiblesDispatch] = useReducer(
    turnosDisponibles,
    turnosDisponiblesInitialState
  );
  const [multitabSinTurnoState, multitabSinTurnoDispatch] = useReducer(
    multitabSinTurno,
    multitabSinTurnoInitialState
  );
  const [preguntasFrecuentesState, preguntasFrecuentesDispatch] = useReducer(
    preguntasFrecuente,
    preguntasFrecuentesInitialState
  );
  const [ordenEstudioState, ordenEstudioDispatch] = useReducer(
    ordenEstudio,
    ordenEstudioInitialState
  );
  const [ordenLaboratorioState, ordenLaboratorioDispatch] = useReducer(
    ordenLaboratorio,
    ordenLaboratorioInitialState
  );
  const [recetasDigitalesState, recetasDigitalesDispatch] = useReducer(
    recetasDigitales,
    recetasDigitalesInitialState
  );
  const [certificadoState, certificadoDispatch] = useReducer(
    certificado,
    certificadoInitialState
  );
  const [portalExteriorState, portalExteriorDispatch] = useReducer(
    portalExterior,
    portalExteriorPacienteInitialState
  );
  const [turnosPacienteState, turnosPacienteDispatch] = useReducer(
    turnosPaciente,
    turnosPacienteInitialState
  );
  const [mercadoPagoState, mercadoPagoDispatch] = useReducer(
    mercadoPago,
    mercadoPagoInitialState
  );
  const [motivoCancelacionState, motivoCancelacionDispatch] = useReducer(
    motivoCancelacion,
    motivoCancelacionInitialState
  );
  const [ayudaState, ayudaDispatch] = useReducer(ayuda, ayudaInitialState);

  const [labOrdenDigitalState, labOrdenDigitalDispatch] = useReducer(
    labOrdenDigital,
    labOrdenDigitalInitialState
  );
  const [ordenDigitalState, ordenDigitalDispatch] = useReducer(
    ordenDigital,
    ordenDigitalInitialState
  );
  const [grupoFamiliarState, grupoFamiliarDispatch] = useReducer(
    grupoFamiliar,
    grupoFamiliarInitialState
  );
  const [listaFamiliaresState, listaFamiliaresDispatch] = useReducer(
    listaFamiliares,
    listaFamiliaresInitialState
  );
  const [selectDropDownState, selectDropDownDispatch] = useReducer(
    selectDropDown,
    selectDropDownInitialState
  );
  const [altaProtocoloPcrState, altaProtocoloPcrDispatch] = useReducer(
    altaProtocoloPcr,
    altaProtocoloPcrInitialState
  );
  const [vcTokenState, vcTokenDispatch] = useReducer(
    vcToken,
    vcTokenInitialState
  );
  const [cardVideoTutorialesState, cardVideoTutorialesDispatch] = useReducer(
    cardVideoTutoriales,
    initialStateCardVideoTutoriales
  );
  const [enviarMailState, enviarMailDispatch] = useReducer(
    enviarMail,
    enviarMailInitialState
  );
  const [tokenFCMState, tokenFCMDispatch] = useReducer(
    tokenFCM,
    tokenFCMInitialState
  );
  const [notificacionesState, notificacionesDispatch] = useReducer(
    notificacionesReducer,
    notificaionInitialState
  );
  const [dispositivoPacienteState, dispositivoPacienteDispatch] = useReducer(
    dispositivoPaciente,
    dispositivoPacienteInitialState
  );
  const [alertasState, alertasDispatch] = useReducer(
    alertas,
    alertasInitialState
  );
  const [presentismoState, presentismoDispatch] = useReducer(
    presentismo,
    presentismoInitialState
  );
  const [beneficiosState, beneficiosDispatch] = useReducer(
    beneficios,
    beneficiosInitialState
  );
  const [pdfOrdenDigitalState, pdfOrdenDigitalDispatch] = useReducer(
    pdfOrdenDigital,
    pdfOrdenDigitalInitialState
  );

  //RESET CONTEXT
  const arrayDispatch = [
    modalDispatch,
    localidadDispatch,
    obraSocialDispatch,
    planObraSocialDispatch,
    verificaDniDispatch,
    registroDispatch,
    multiTabDispatch,
    validaMobileDispatch,
    pacienteDispatch,
    tokenDispatch,
    estudioGrupoDispatch,
    familiaresDispatch,
    laboGrupoDispatch,
    laboTurnosDispatch,
    misMedicosDispatch,
    misLaboratoriosDispatch,
    misInformesDispatch,
    cancelacionDispatch,
    tokenGoogleDispatch,
    estudioTurnosDispatch,
    consultaMedTurnosDispatch,
    sugerenciaDispatch,
    turnosDisponiblesDispatch,
    atencionSinTurnoDispatch,
    multitabSinTurnoDispatch,
    preguntasFrecuentesDispatch,
    ordenEstudioDispatch,
    ordenLaboratorioDispatch,
    recetasDigitalesDispatch,
    certificadoDispatch,
    portalExteriorDispatch,
    turnosPacienteDispatch,
    mercadoPagoDispatch,
    motivoCancelacionDispatch,
    ayudaDispatch,
    grupoFamiliarDispatch,
    listaFamiliaresDispatch,
    selectDropDownDispatch,
    altaProtocoloPcrDispatch,
    segundoModalDispatch,
    vcTokenDispatch,
    cardVideoTutorialesDispatch,
    enviarMailDispatch,
    tokenFCMDispatch,
    hashDispatch,
    notificacionesDispatch,
    dispositivoPacienteDispatch,
    alertasDispatch,
    labOrdenDigitalDispatch,
    ordenDigitalDispatch,
    presentismoDispatch,
    beneficiosDispatch,
    pdfOrdenDigitalDispatch,
  ];

  const sessionStorageExclusion = [];
  const localStorageExclusion = [
    "config",
    "_cap_welcomeActive",
    "mercadoPago",
    "subidaOrden",
    "dtoSegundoFactor",
  ];

  const limpiarStorage = (sessionExcepcion, localExcepcion) => {
    //limpiar sessionStorage
    if (Object.keys(sessionStorage).length > 0) {
      Object.keys(sessionStorage).map(
        (key) =>
          !sessionExcepcion.includes(key) && sessionStorage.removeItem(key)
      );
    }
    //limpiar localStorage
    if (Object.keys(localStorage).length > 0) {
      Object.keys(localStorage).map(
        (key) => !localExcepcion.includes(key) && localStorage.removeItem(key)
      );
    }
  };

  const resetPortalContext = (index) => {
    if (Array.isArray(arrayDispatch)) {
      if (index >= arrayDispatch.length) {
        limpiarStorage(sessionStorageExclusion, localStorageExclusion);
        return;
      }
      const dispatch = arrayDispatch[index];
      dispatch({ type: RESET_PORTAL_CONTEXT });
      resetPortalContext(index + 1);
    }
  };

  const history = useHistory();
  useEffect(() => {
    const screen = window?.screen;
    if (screen) {
      Network.addListener("networkStatusChange", (status) => {
        if (!status.connected) {
          history.push("/");
        }
      });
    }
  }, []);

  return (
    <PortalContext.Provider
      value={{
        modalState,
        modalDispatch,
        localidadState,
        localidadDispatch,
        obraSocialState,
        obraSocialDispatch,
        planObraSocialState,
        planObraSocialDispatch,
        verificaDniState,
        verificaDniDispatch,
        registroState,
        registroDispatch,
        multiTabState,
        multiTabDispatch,
        validaMobileState,
        validaMobileDispatch,
        pacienteState,
        pacienteDispatch,
        tokenState,
        tokenDispatch,
        estudioGrupoState,
        estudioGrupoDispatch,
        familiaresState,
        familiaresDispatch,
        laboGrupoState,
        laboGrupoDispatch,
        laboTurnosState,
        laboTurnosDispatch,
        misMedicosState,
        misMedicosDispatch,
        misLaboratoriosState,
        misLaboratoriosDispatch,
        misInformesState,
        misInformesDispatch,
        cancelacionState,
        cancelacionDispatch,
        tokenGoogleState,
        tokenGoogleDispatch,
        estudioTurnosState,
        estudioTurnosDispatch,
        textosState,
        textosDispatch,
        consultaMedTurnosState,
        consultaMedTurnosDispatch,
        sugerenciaState,
        sugerenciaDispatch,
        turnosDisponiblesState,
        turnosDisponiblesDispatch,
        atencionSinTurnoState,
        atencionSinTurnoDispatch,
        multitabSinTurnoState,
        multitabSinTurnoDispatch,
        preguntasFrecuentesState,
        preguntasFrecuentesDispatch,
        ordenEstudioState,
        ordenEstudioDispatch,
        ordenLaboratorioState,
        ordenLaboratorioDispatch,
        recetasDigitalesState,
        recetasDigitalesDispatch,
        certificadoState,
        certificadoDispatch,
        portalExteriorState,
        portalExteriorDispatch,
        turnosPacienteState,
        turnosPacienteDispatch,
        mercadoPagoState,
        mercadoPagoDispatch,
        motivoCancelacionState,
        motivoCancelacionDispatch,
        ayudaState,
        ayudaDispatch,
        grupoFamiliarState,
        grupoFamiliarDispatch,
        listaFamiliaresState,
        listaFamiliaresDispatch,
        selectDropDownState,
        selectDropDownDispatch,
        altaProtocoloPcrState,
        altaProtocoloPcrDispatch,
        segundoModalState,
        segundoModalDispatch,
        vcTokenState,
        vcTokenDispatch,
        cardVideoTutorialesState,
        cardVideoTutorialesDispatch,
        enviarMailState,
        enviarMailDispatch,
        tokenFCMState,
        tokenFCMDispatch,
        notificacionesState,
        notificacionesDispatch,
        dispositivoPacienteState,
        dispositivoPacienteDispatch,
        alertasState,
        alertasDispatch,
        labOrdenDigitalState,
        labOrdenDigitalDispatch,
        ordenDigitalState,
        ordenDigitalDispatch,
        presentismoState,
        presentismoDispatch,
        beneficiosState,
        beneficiosDispatch,
        pdfOrdenDigitalState,
        pdfOrdenDigitalDispatch,
        hashState,
        hashDispatch,
        resetPortalContext,
      }}
    >
      {children}
    </PortalContext.Provider>
  );
};
